import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Request failed";
}

// Fire-and-forget event tracking
export function track(event_name, properties = {}) {
  try {
    const utm = JSON.parse(sessionStorage.getItem("aidelta_utm") || "{}");
    api.post("/events", { event_name, properties_json: properties, utm }).catch(() => {});
    if (typeof window.gtag === "function") {
      window.gtag("event", event_name, properties);
      // Mirror to GA4's recommended event so signups appear in standard reports.
      if (event_name === "signup_completed") {
        window.gtag("event", "sign_up", { method: properties.method || "email" });
      }
    }
    if (typeof window.lintrk === "function" && LINKEDIN_CONVERSIONS[event_name]) {
      window.lintrk("track", { conversion_id: LINKEDIN_CONVERSIONS[event_name] });
    }
    if (typeof window.oaiq === "function" && OAIQ_EVENTS[event_name]) {
      window.oaiq("measure", OAIQ_EVENTS[event_name], { type: "customer_action", amount: 0, currency: "USD" });
    }
  } catch (e) {
    console.debug("track event skipped:", e?.message || e);
  }
}

// LinkedIn conversion IDs (create in Campaign Manager > Conversions, then fill in).
const LINKEDIN_CONVERSIONS = {
  // signup_completed: 12345678,
  // checkout_started: 12345679,
};

// OpenAI (ChatGPT Ads) pixel: conversions are sent SERVER-SIDE via the
// Conversions API (backend ads.py) — the pixel handles page views/attribution only.
const OAIQ_EVENTS = {};

export default api;
